export const frappeConfig = {
    company: "BuildX",
    posProfile: "Antico",
};

export const isRoleAdmin = (role) => {
    return role === "admin" || role === "Admin" || role === "POS-ADMIN" || role === "Administrator";
};

export const isRoleService = (role) => {
    return role === "Service";
};

export const SPECIAL_ROLE_PROFILES = Object.freeze({
    KDS_TABS: "KDS_TABS",
    KIOSK_PREVIEW: "KIOSK_PREVIEW",
    KIOSK: "KIOSK",
});

export const getSpecialRoleLandingPath = (role) => {
    switch (role) {
        case SPECIAL_ROLE_PROFILES.KDS_TABS:
            return "/kds-tabs";
        case SPECIAL_ROLE_PROFILES.KIOSK_PREVIEW:
            return "/kiosk-preview";
        case SPECIAL_ROLE_PROFILES.KIOSK:
            return "/kiosk";
        default:
            return null;
    }
};

export const getAccessibleCompanyByName = (companies, companyName) => {
    if (!Array.isArray(companies) || !companyName) return null;
    return companies.find((company) => company?.name === companyName) || null;
};

/**
 * Match ERPNext's POS Profile User access rules for restricted POS roles.
 * Explicit assignments win; otherwise only unassigned profiles are shared.
 */
export const getAccessiblePosProfiles = (profiles, userName, role) => {
    const availableProfiles = Array.isArray(profiles) ? profiles : [];
    const usesAssignedProfile =
        isRoleService(role) ||
        role === SPECIAL_ROLE_PROFILES.KIOSK ||
        role === SPECIAL_ROLE_PROFILES.KIOSK_PREVIEW;

    if (!usesAssignedProfile) {
        return availableProfiles;
    }

    if (!userName) return [];

    const enabledProfiles = availableProfiles.filter(
        (profile) => Number(profile?.disabled) !== 1
    );
    const assignedProfiles = enabledProfiles.filter((profile) =>
        (profile?.applicable_for_users || []).some(
            (profileUser) => profileUser?.user === userName
        )
    );

    if (assignedProfiles.length > 0) {
        return assignedProfiles;
    }

    return enabledProfiles.filter(
        (profile) =>
            !(profile?.applicable_for_users || []).some(
                (profileUser) => Boolean(profileUser?.user)
            )
    );
};

export const isRolePos = (role) => {
    return role === "Cashier";
};
